export const environment = {
	production: false,
	apiUrl: 'https://apigateway.virtualservers.work/v1/',
	apiUrlSocket: 'https://apigateway.virtualservers.work/',
	loginPath: 'security/login',
	timeIntervalChecker: 1000,
	limitSecondsInactivity: 64800,
	limitSecondsBeforeNotifyInactivity: 240,
	apikeyTiny: "002a281rfyx718xrsbpu36qmuymfk9o6j9ydpyqn73mzk6yx",
	firebaseConfig: {
		apiKey: 'AIzaSyBAnaNbguLYcj-Ss29ZvjjUWxUEYWb7wqY',
		authDomain: 'academic-jamestown.firebaseapp.com',
		databaseURL: 'https://academic-jamestown.firebaseio.com',
		projectId: 'academic-jamestown',
		storageBucket: 'academic-jamestown.appspot.com',
		messagingSenderId: '369044697282',
		appId: '1:369044697282:web:d4a9c30e98798287ac0b5b',
		measurementId: 'G-LFWLX5YYKE',
		idGA: 'UA-232355407-1'
	}
};
